import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hf-opt-in-out',
  templateUrl: './opt-in-out.component.html',
  styleUrls: ['./opt-in-out.component.scss']
})
export class OptInOutComponent {
  @Input() optedIn: boolean;
}
